import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Titre from '../UI/Titre.jsx'
import Description from '../UI/Description.jsx';
import Remerciement from '../UI/Remerciement.jsx';
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import { useCallback, useEffect, useState } from 'react';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Temoinage from '../UI/Temoinage.jsx';
import Accueil from '../UI/Accueil.jsx';

function VOC076200({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVocale,
    changerEtapeCollecteParticipationTexte,

    setContinueEnabled,
    continueEnabled,

    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendRecordParticipation,
    sendingParticipationState,
    passerPageTemoignage,
    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setRememberMe,
    setField,
    saveDonneePersonnelle,
    setMessageErreur,
    retourAccueil,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    userInformation,
    donneesPersonnelleValid,
    participation,
}) {

    const {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur,
    } = ManageCompteur(interaction);

    const handleStartRecording = useCallback(
        (status) => {
            if (status === 'start') {
                startCountdownTimer();
            }
            if (status === 'stop') {
                stopCountdownTimer();
                setAfficherCompteur(true);
            }
        },
        [setAfficherCompteur, startCountdownTimer, stopCountdownTimer]
    );

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );

    // Masque le compteur une fois qu'audioURL est définit.
    useEffect(() => {
        if (audioURL !== '') {
            setAfficherCompteur(false);
        }
    }, [audioURL, setAfficherCompteur]);

    const [afficherEtapeCollecteParticipationImage, setAfficherEtapeCollecteParticipationImage] = useState(true);

    return (
        <>
                <Row className="custom-title-instructions">
                    <Col>
                        <Titre interaction={interaction} />
                    </Col>
                </Row>
            {afficherAccueil &&
                // Page d accueil
                <>
                    <Accueil
                        interaction={interaction}
                        changerPage={changerAfficherEtapeCollecteParticipation}
                    />
                </>
            }
            {afficherEtapeCollecteParticipation &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <Row className="custom-instructions">
                        <Col>
                            <Description interaction={interaction} />
                        </Col>
                    </Row>
                    <Temoinage
                        interaction={interaction}
                        audioURL={audioURL}
                        setAudioURL={setAudioURL}
                        audioBlob={audioBlob}
                        setAudioBlob={setAudioBlob}
                        sendRecordParticipation={sendRecordParticipation}
                        maxRecordingTime={interaction.max_recording_time}
                        setContinueEnabled={setContinueEnabled}
                        setMessageErreur={setMessageErreur}
                        sendingParticipationState={sendingParticipationState}
                        participation={participation}
                        changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                        changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                        retourAccueil={retourAccueil}
                        handleStartRecording={handleStartRecording}
                        counter={counter}
                        afficherCompteur={afficherCompteur}
                        handleAfficherCompteur={handleAfficherCompteur}
                        showRetour={!afficherEtapeCollecteParticipationImage}
                        setAfficherEtapeCollecteParticipationImage={setAfficherEtapeCollecteParticipationImage}
                        passerPageTemoignage={passerPageTemoignage}
                    />
                </>
            }
            {afficherEtapeCollectInformationsPersonnelles &&
                <>

                    <DonneesPersonnelles
                        interaction={interaction}
                        setField={setField}
                        userInformation={userInformation}
                        donneesPersonnelleValid={donneesPersonnelleValid}
                        handleRememberMeChange={handleRememberMeChange}
                        rememberMe={rememberMe}
                        canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                        saveDonneePersonnelle={saveDonneePersonnelle} />
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de collecte de données personnelles
            }
            {afficherEtapeGRPD &&
                <>
                    <Consent
                        customisation={interaction.segment_customisation}
                        consentGDPR={consentGDPR}
                        consentImage={consentImage}
                        setConsent={setConsent}
                    />
                    <Row className="custom-commandes">
                        <Col>
                            <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled}>Continuer</Button>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de consentement
            }
            {afficherEtapeRemerciement &&
                <>
                    <Row className="custom-commandes">
                        <Col>
                            <Remerciement interaction={interaction} >Continuer</Remerciement>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>

                </>
                // Page de remerciemeent
            }
        </>
    )
}
export default VOC076200;
